<template>
  <div
    class="main">
    <module-title :module-title="moduleTitle"/>
    <div class="laywer-list double-between">
      <div v-for="(item, index) in list" :key="index">
        <div v-if="index < 3" class="laywer-list-item" @click="goLawyer(item.id, item.userId)">
          <div class="address" v-if="item.lawyerLevel === 1">名家律师</div>
          <div class="address" v-if="item.lawyerLevel === 3">资深律师</div>
          <div class="address" v-if="item.lawyerLevel === 2">专家律师</div>
          <div class="address address2" v-if="item.lawyerLevel === 4 || !item.lawyerLevel"></div>
          <div class="logo">
            <img :src="item.faceUrl">
          </div>
          <div class="name">{{ item.realName }}</div>
          <div class="year">执业{{ item.yearPractice }}年</div>
          <div class="service">{{ formatField(item.skillField) + '...' }}</div>
          <div class="button">
            <img src="https://cdn.51ljb.cn/ljb_icons_service_zx.png">
            咨询
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleTitle from '@/components/title/ModuleTitleNew'
import AREA from '@/libs/utils/area.json'
import {mapGetters} from 'vuex'

const ProvincesList = AREA.province_list
let namespce = 'Channel'
export default {
  name: 'ListService',
  components: {ModuleTitle},
  data () {
    return {
      moduleTitle: {
        title: '热门律师',
        text: '查看更多',
        url: 'Lawyer'
      },
      field4List: this.$dataResource.FIELD_LIST_MLIST,
      list: []
    }
  },
  computed: {
    ...mapGetters(namespce, ['getChannelData']),
    // lawyerList () {
    //   if (this.getChannelData) {
    //     if (this.getChannelData.activity && Object.keys(this.getChannelData.activity).length > 0) {
    //       return this.getChannelData.activity
    //     }
    //   }
    //   return null
    // }
  },
  mounted() {
    this.getData()
  },
  methods: {
    goDoc: function (item) {
      this.$utils.checkCanGoRouter(item.url)
    },
    getData() {
      this.$get.homeLawyerList().then(res => {
        this.list  = res.data
      })
    },
    formatField (str) {
      if (!str) return
      if(str.length === 1) {
        return this.field4List.find(i => {
          return str === i.value
        }).label
      } else {
        let arr = str.split(',').slice(0,1)
        const newarr = []
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < this.field4List.length; j++) {
            if (arr[i] === this.field4List[j].value) {
              newarr.push(this.field4List[j].label)
            }
          }
        }
        return newarr.join('、')
      }
    },
    formatCity(code) {
      if (!code) return
      let a = ProvincesList[code.slice(0, 2) + '0000'] || ''
      // let b = CityList[code.slice(0, 4) + '00'] || ''
      // let c = CountyList[code] || ''
      return a
    },
    goLawyer(id, userId) {
      this.$router.push({name: 'LawyerInfo', params: {id: id, sub: userId}})
    },
  }
}
</script>

<style lang="scss" scoped>
  .main{
    // margin-top: $margin;
    background: #fff;
    padding-bottom: $padding;
  }
  .laywer-list{
    padding:0 $padding 0 $padding;
    box-sizing:  border-box;
    .laywer-list-item{
      width: 108px;
      height: 170px;
      background: linear-gradient(180deg, #FFF4DD 0%, #FEECC9 100%);
      border-radius: 5px;
      position: relative;
      .address{
        width: 60px;
        height: 22px;
        background: linear-gradient(180deg, #FEF8E9 0%, #FFE4B0 100%);
        border-radius: 0px 0px 2px 0px;
        text-align: center;
        line-height: 22px;
        font-size: 12px;
        font-weight: 400;
        color: #B98727;
      }
      .address2{
        background: transparent;
      }
      .logo{
        width: 50px;
        height: 50px;
        border-radius: 25px;
        overflow: hidden;
        position: absolute;
        top: 18px;
        left: 0;
        right: 0;
        margin: 0 auto;
        >img{
          width: 100%;
          height: 100%;
        }
      }
      .name{
        text-align: center;
        font-size: 15px;
        font-weight: 500;
        color: #89631B;
        margin-top: 50px;
      }
      .year{
        font-size: 13px;
        color: #89631B;
        margin-top: 1px;
        text-align: center;
      }
      .service{
        font-size: 12px;
        color: #89631B;
        margin-top: 1px;
        text-align: center;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        height: 17px;
      }
      .button{
        width: 75px;
        height: 28px;
        background: #FFFBF2;
        border-radius: 28px;
        margin: 6px auto 0;
        text-align: center;
        line-height: 28px;
        >img{
          vertical-align: middle;
          margin-top: -2px;
          width: 14px;
          height: 12px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/list/ListLawyer.vue